<template>
  <iframe
    class="m-2 p-2"
    :src="this.settings.src"
    :style="this.settings.style"
    :class="this.settings.class"
    width="80%"
    height="800vh"
  />
</template>

<script>
export default {
  created() {
    if (!this.isAllowed) {
      this.$router.push('/');
    }
  },

  mounted() {
    window.addEventListener('applicationEvent', this.handleMessage, false);
  },

  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings.sections.iframe_test_page;
    },

    isAllowed() {
      return this.settings.allowed === true;
    },
  },

  methods: {
    handleMessage(event) {
      if(event?.detail) {
        console.log(JSON.stringify(event.detail));
        alert(JSON.stringify(event.detail));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

